import React, { useState, useEffect } from 'react';
import './RefundPolicyPage.css';

const RefundPolicyPage = () => {
  const [currentSection, setCurrentSection] = useState('intro');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    { id: 'intro', title: 'Introducción', icon: 'fas fa-info-circle' },
    { id: 'paso1', title: 'Paso 1: Información', icon: 'fas fa-list' },
    { id: 'paso2', title: 'Paso 2: Productos a devolver', icon: 'fas fa-box-open' },
    { id: 'paso3', title: 'Paso 3: Referencias a cambio', icon: 'fas fa-exchange-alt' },
    { id: 'aspectos', title: 'Aspectos importantes', icon: 'fas fa-check-circle' },
    { id: 'contacto', title: 'Contacto', icon: 'fas fa-phone' }
  ];

  const renderSectionContent = (sectionId) => {
    switch (sectionId) {
      case 'intro':
        return (
          <div className="refund-section-content">
            <div className="refund-highlight">
              <p><strong>¡TRANQUI!</strong> Es muy fácil, solo debes seguir estos 3 pasos y mandarnos toda la información a nuestro correo de soporte.</p>
              <p><strong>Recuerda:</strong> Todo cambio, devolución o garantía, siempre y cuando sean por imperfecciones de las prendas o problemas de calidad son <strong>COMPLETAMENTE GRATIS</strong>, no debes de preocuparte por nada, nosotros nos encargamos de todos los costos de envío para tu total satisfacción.</p>
            </div>
          </div>
        );

      case 'paso1':
        return (
          <div className="refund-section-content">
            <h3>Paso 1: Cuéntanos la información</h3>
            <p>Cuéntanos la siguiente información:</p>
            <ul>
              <li>El nombre completo del titular del pedido</li>
              <li>La ciudad dónde estás ubicado</li>
              <li>Celular dónde podemos contactarte</li>
              <li>Canal por dónde compraste</li>
              <li><strong>Cuál es el motivo del cambio:</strong>
                <ul>
                  <li><strong>Cambio de talla:</strong> Si es por este motivo debes asumir el envío del producto.</li>
                  <li><strong>Devolución:</strong> Si la prenda llegó con imperfecciones o llegó una prenda que no pediste.</li>
                  <li><strong>Garantía:</strong> Esta cubre en casos de descosidos, desteñidos, costuras, defecto de fábrica.</li>
                </ul>
              </li>
            </ul>
            <p><strong>No cubre:</strong> Los aspectos que no cubre la garantía: cortes o manchas causadas por el uso.</p>
          </div>
        );

      case 'paso2':
        return (
          <div className="refund-section-content">
            <h3>Paso 2: ¿Qué prendas nos vas a entregar?</h3>
            <p>Escribe cuáles son las referencias que nos vas a devolver:</p>
            <ul>
              <li>Nombre del producto</li>
              <li>Talla</li>
              <li>Color</li>
              <li>Cantidad</li>
            </ul>
            <p><strong>Si es una garantía:</strong> Por favor adjuntar una foto del imperfecto dónde se vea el defecto claramente.</p>
          </div>
        );

      case 'paso3':
        return (
          <div className="refund-section-content">
            <h3>Paso 3: ¿Qué referencias quieres a cambio?</h3>
            <p>Cuéntanos si quieres las mismas referencias a cambio o quieres otras diferentes. Recuerda que debe ser por el mismo valor o cubrir el excedente en caso de ser necesario.</p>
          </div>
        );

      case 'aspectos':
        return (
          <div className="refund-section-content">
            <h3>Aspectos que debes tener en cuenta</h3>
            <ul>
              <li>Debes devolver tu prenda en <strong>perfecto estado</strong>, tal cual como la recibiste, sin olores y sin modificaciones.</li>
              <li>Este proceso tardará aproximadamente <strong>8-10 días hábiles</strong>.</li>
              <li>Los costos de envío para cambios, devoluciones o garantías son <strong>GRATIS</strong>, siempre y cuando no sean por tallas.</li>
              <li>Nuestra política tiene una duración de <strong>30 días</strong>. Si han pasado más de 30 días desde tu compra, por desgracia no podemos ofrecer un reembolso o cambio.</li>
              <li>Para devolver tu producto, debes enviarlos a nuestra dirección de devoluciones (se te proporcionará al contactarnos).</li>
              <li>Dependiendo de dónde vivas, el tiempo que tome recibir el producto intercambiado, puede variar.</li>
              <li>Cuando envíes el producto de vuelta, si su valor supera <strong>$300.000</strong> te recomendamos usar un servicio con seguimiento o seguro. Así podrás demostrar que lo enviaste y nosotros podremos confirmar la recepción.</li>
            </ul>
          </div>
        );

      case 'contacto':
        return (
          <div className="refund-section-content">
            <h3>¿Necesitas ayuda?</h3>
            <p>Para iniciar un proceso de devolución, cambio o garantía, contáctanos:</p>
            <ul>
              <li><strong>Email:</strong> support@javiland.com</li>
              <li><strong>Horario:</strong> Lunes a Viernes de 9am a 6pm</li>
            </ul>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="refund-page">
      <div className="refund-container">
        <div className="refund-header">
          <button
            className="back-button"
            onClick={() => {
              window.history.pushState({}, '', '/');
              window.dispatchEvent(new PopStateEvent('popstate'));
            }}
          >
            <i className="fas fa-arrow-left"></i>
            Volver al Inicio
          </button>
          <div className="refund-logo">
            <img src="/images/Logo_Javiland_Largo.png" alt="Javiland" />
          </div>
          <h1>Política de Devoluciones</h1>
          <p className="refund-subtitle">Última actualización: Diciembre 2025</p>
        </div>

        <div className="refund-body">
          <div className="refund-sidebar">
            <nav className="refund-navigation">
              {sections.map((section) => (
                <button
                  key={section.id}
                  className={`refund-nav-item ${currentSection === section.id ? 'active' : ''}`}
                  onClick={() => setCurrentSection(section.id)}
                >
                  <i className={section.icon}></i>
                  <span>{section.title}</span>
                </button>
              ))}
            </nav>
          </div>

          <div className="refund-content">
            <div className="refund-scrollable">
              {renderSectionContent(currentSection)}

              <div className="refund-footer">
                <h4>Nota importante</h4>
                <p>Esta Política de Devoluciones es parte integral de nuestros Términos y Condiciones. Al realizar una compra, usted acepta esta política.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicyPage;
